import type { RouteObject } from 'react-router';
import { AccountPage } from './AccountPage';
import { LoginPage } from './LoginPage';

/** Rendered outside the authenticated shell. */
export const publicRoutes: RouteObject[] = [{ path: '/login', element: <LoginPage /> }];

export const routes: RouteObject[] = [{ path: '/account', element: <AccountPage /> }];
